export const mapStateToProps = (state) => {
    const {
        ui: {
            selectedGeoObj,
            dateRangeCriteria,
            rangeStartDate,
            rangeEndDate,
            selectedGeoObjArray
        } = {},
        api: {
            geoObjRoute,
            geoObjReportExcel,
            workingTimeSheet
        } = {},
        service: {
            Api: {
                getGeoObjRoute,
                getGeoObjReportExcel,
                getWorkingTimeSheet,
            } = {},
            Route: {
                loadRoute,
            } = {}
        } = {}
    } = state;
    return {
        selectedGeoObj,
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
        geoObjRoute,
        geoObjReportExcel,
        getGeoObjRoute,
        loadRoute,
        getGeoObjReportExcel,
        selectedGeoObjArray,
        getWorkingTimeSheet,
        workingTimeSheet
    }
}